import { Checkbox, Tooltip } from '@airbus/components-react';
import styles from './MultiHtzCheckbox.module.css';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { t } from '../../../i18next';

export default function MultiHtzCheckbox({ handleChangeHTZ }) {
  return (
    <div className={styles.checkBoxMainDiv} style={{ maxWidth: 'max-content', maxHeight: 'max-content' }}>
      <div className={styles.checkBoxConfirmStylOuter}>
        <div>
          <label htmlFor='multi_htz_search' className={styles.checkBoxConfirmStyle}>
            <Checkbox id='multi_htz_search' onChange={handleChangeHTZ} />
            {t('part_search.multi_htz_search_label')}
            <div className={styles.multiHtzTooltipContainer}>
              <Tooltip
                label={t('part_search.multi_htz_search_tooltip')}
                className={styles.multiHtzTooltip}
                style={{ maxWidth: 'max-content' }}
              >
                <InfoOutlineIcon fontSize='small' />
              </Tooltip>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}
